import React, { useEffect, useState } from "react";
import { Checkbox, Button, Grid, } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import {
  trakrefFontFamily,
  trakrefFontFamilySemiBold,
  trakrefFontSFProTextSemibold,
} from "../../../utils";
import "./SiteAirFilter.css";
import { trakrefBlue, Grey2, } from "../../../color_utils";
import { Table, Column } from "../../Common";
import Routes from "../../../routes";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';

function SiteTable(props) {
  const [allSelected, setAllSelected] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [data, setData] = useState([]); // set CheckedData
  const [dataTableLength, setDataTableLength] = useState(0);
  const [changeOutData, setChangeOutData] = useState([]);
  const handleSelectAllCheckBox = () => {
    setIsChecked(!isChecked);

    setAllSelected(!allSelected);
    if(!allSelected) {
      props.dataUpdated([]);

      setChangeOutData([]);
      setData([]);
    }
  };

  // FOR CHANGE OUT STATUS COLUMN
  useEffect(() => {
    if(data.some) {
      setChangeOutData(changeOutData.filter((obj) => data.some((item) => item.id === obj.id)));
    }
  }, [data]);

  const MarkAsChangedOut = () => {
    var changeOutDataTemp = [];
    var pendingDataTemp = [];

    if(changeOutData.length == 0) {
      data.map((obj) => {
        if (changeOutData.some((item) => item.id === obj.id)) { // remove from change out list
          pendingDataTemp.push(obj)
        } else { // add to change out list
          changeOutDataTemp.push(obj)
        }
      });
      var finalData = [...changeOutData.filter((obj) => !pendingDataTemp.some((item) => item.id === obj.id)), ...changeOutDataTemp]
      setChangeOutData(finalData)
    } else {
      setChangeOutData([])
    }
}

  const SelectAllTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} 
      classes={{ popper: className }} 
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -20, 0, 0],
            },
          },
        ]
      }
    } />
    ))(({ theme }) => ({
      [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: Grey2,
        boxShadow: theme.shadows[1],
        fontSize: 12,
        fontFamily: trakrefFontFamily,
      },
  }));

  return (
    <TableContainer component={Paper}>
      <Grid container justifyContent="space-between" style={{ marginBottom: "9px" }}>
        <Grid item xs={8} marginLeft={1.7}>
          <SelectAllTooltip title="Select All">
            <Checkbox
              indeterminate={dataTableLength != data.length && data.length > 0}
              indeterminateIcon={<IndeterminateCheckBoxOutlinedIcon/>}
              style={{ marginLeft: 29}}
              checked={(dataTableLength == data.length && data.length > 0)}
              onChange={handleSelectAllCheckBox}
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 30,
                  color: trakrefBlue,
                },
              }}
            />
          </SelectAllTooltip>
          <span
            style={{
              color: Grey2,
              fontSize: "12px",
              fontFamily: trakrefFontSFProTextSemibold,
              marginLeft: '12px',
            }}
            hidden={data.length <= 0 || data.length === undefined}
          >
            {(dataTableLength == data.length && data.length > 0)
              ? `All ${data.length} systems on this page are selected.`
              : `${data.length} selected`}
          </span>
        </Grid>

        <Grid item marginRight={4} marginTop={1}>
          <Button
            hidden={data.length <= 0}
            variant="outlined"
            onClick={MarkAsChangedOut}
            sx={{
              fontSize: "0.75rem",
              fontFamily: trakrefFontFamilySemiBold,
              color: trakrefBlue,
              borderColor: trakrefBlue,
              textTransform: "none",
              ":hover": { borderColor: trakrefBlue },
            }}
          >
            Mark As Changed Out
          </Button>
        </Grid>
      </Grid>

      <Table
        url={Routes.ServiceEvent.SiteAirFilterTable(props.woID)}
        renderDefaultFilter={false}
        isAllSelected={allSelected}
        onRowsUpdated={(data) => {
          props.dataUpdated(data);
          setData(data);
        }}
        onFetchSuccess={(loadedData) => {
          setDataTableLength(loadedData.rows.length ? loadedData.rows.length : 0);
        }}
        refresh={false}
        noResultText="Oops...It is empty here..."
      >
        <Column
          isCheckBox={true}
          width="65px"
        />

        <Column
          id="systemNameHeader"
          title="SYSTEM NAME"
          property="name"
          filter="text"
        />
        <Column
          id="MaterialTypeHeader"
          title="MATERIAL TYPE"
          property="materialTypeName"
          filter="text"
        />
        <Column
          id="TagNumberHeader"
          title="tagNumber"
          property="tagNumber"
          filter="text"

        />
        <Column
          id="SerialNumberHeader"
          title="SERIAL NUMBER"
          property="serialNumber"
          filter="text"
        />
        <Column
          id="GasCapacityHeader"
          title="GAS CAPACITY"
          property="gasChargeCapacity"
          filter="text"
          type="weight"
        />
        <Column 
          id="StatusHeader" 
          title="STATUS" 
          filter="dropdown" 
          isSAFstatus={true} 
          changeOutData={changeOutData} />
      </Table>
    </TableContainer>
  );
}

export default SiteTable;
